<template>
    <div class="forum-loader-before">
        <Loader></Loader>
        <hr class="hr-33">
        <hr class="hr-66">
    </div>
</template>

<script>
    // ForumLoaderBefore: a loading animation stylized for the forum to indicate
    // that something is loading before the previous set of results.

    import Loader from './loader';

    export default {
        components: {
            Loader,
        },
    }
</script>

<style lang="scss" scoped>
    hr {
        border-color: #333;
        margin: 20px auto;
    }
    .hr-33 {
        opacity: 0.4;
        width: calc(100% - 40px);
    }
    .hr-66 {
        opacity: 0.66;
        width: calc(100% - 20px);
    }
</style>



// WEBPACK FOOTER //
// loader-before.vue?4300be85